export const API_BASE = import.meta.env.VITE_API_URL ?? "https://enque-api.s-fx-com.workers.dev/v1";

export class ApiError extends Error {
  constructor(public readonly status: number, message: string) {
    super(message);
    this.name = "ApiError";
  }
}

export function createApiClient(token: string, workspaceId: string | null) {
  async function request<T>(path: string, init?: RequestInit): Promise<T> {
    const resp = await fetch(`${API_BASE}${path}`, {
      ...init,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        ...(workspaceId ? { "X-Workspace-Id": workspaceId } : {}),
        ...(init?.headers ?? {}),
      },
    });

    const json = await resp.json() as { data?: T; message?: string };

    if (!resp.ok) {
      throw new ApiError(resp.status, json.message ?? "Request failed");
    }

    return json.data as T;
  }

  return {
    get: <T>(path: string) => request<T>(path),
    post: <T>(path: string, body: unknown) =>
      request<T>(path, { method: "POST", body: JSON.stringify(body) }),
    patch: <T>(path: string, body: unknown) =>
      request<T>(path, { method: "PATCH", body: JSON.stringify(body) }),
    delete: <T>(path: string) => request<T>(path, { method: "DELETE" }),
  };
}
